import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgCheck = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.74962 12.8787L15.816 5.0791L18.1841 6.92092L10.2504 17.1213L4.06299 12.1713L5.93707 9.82871L9.74962 12.8787Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgCheck);

export default ForwardRef;
